import { internal, template } from '../../vendor/elix.js';

function FilledInputMixin(Base) {

  return class FilledInput extends Base {

    get [internal.template]() {

      const innerSelector = this.innerSelector || '#inner';

      return template.concat(

        super[internal.template],

        template.html`

          <style>

            :host {
              outline: none;
              --tp-text-field-icon-slot-top: 30px;
              position: relative;
            }

            ${innerSelector} {
              background-color: var(--tp-filled-input-mixin-background-color);
              border: none;
              border-bottom-style: solid;
              border-top-left-radius: 4px;
              border-top-right-radius: 4px;
              outline: none;
              padding: var(--tp-filled-input-mixin-padding);
              transition: var(--tp-filled-input-mixin-transition);
            }

            ${innerSelector}:not(.empty) {
              border-bottom-width: var(--tp-filled-input-mixin-border-width-not-empty);
              border-bottom-color: var(--tp-filled-input-mixin-border-color-not-empty);
            }

            ${innerSelector}.empty {
              border-bottom-width: var(--tp-filled-input-mixin-border-width-empty);
              border-bottom-color: var(--tp-filled-input-mixin-border-color-empty);
            }

            .inputStateContainer {
              transition: var(--tp-filled-input-mixin-transition);
            }

            .inputStateContainer.disabled ${innerSelector} {
              background-color: var(--tp-filled-input-mixin-background-color-disabled);
              border-bottom-color:  var(--tp-filled-input-mixin-border-color-disabled);
            }

            .inputStateContainer:not(.focused):not(.error):not(:hover) ${innerSelector}.empty,
            .inputStateContainer.disabled ${innerSelector}.empty {
              border-bottom-left-radius: 4px;
              border-bottom-right-radius: 4px;
            }

            .inputStateContainer:not(.focused):not(.disabled):not(.error):hover ${innerSelector}.empty {
              border-bottom-color: var(--tp-filled-input-mixin-border-color-hover);
              border-bottom-width: var(--tp-filled-input-mixin-border-width-hover);
              padding: var(--tp-filled-input-mixin-padding-hover);
            }

            .inputStateContainer:not(.disabled):not(.error):hover ${innerSelector}:not(:focus) {
              background-color: var(--tp-filled-input-mixin-background-color-hover);
            }

            .inputStateContainer:not(.disabled) ${innerSelector}:focus,
            .inputStateContainer:not(.disabled) ${innerSelector}:active {
              background-color: var(--tp-filled-input-mixin-background-color-focused);
              border-bottom-width: var(--tp-filled-input-mixin-border-width-focused);
              padding: var(--tp-filled-input-mixin-padding-focused);
            }

            .inputStateContainer:not(.disabled):not(.error) ${innerSelector}:focus,
            .inputStateContainer:not(.disabled):not(.error) ${innerSelector}:active {
              border-bottom-color:  var(--tp-filled-input-mixin-border-color-focused);
            }

            .inputStateContainer.error ${innerSelector} {
              border-bottom-color:  var(--tp-filled-input-mixin-border-color-error);
              border-bottom-width: var(--tp-filled-input-mixin-border-width-error);
              padding: var(--tp-filled-input-mixin-padding-error);
            }

            .inputStateContainer.with-leading-slot-contents ${innerSelector} {
              padding-left: 48px !important;
            }

            .inputStateContainer.with-trailing-slot-contents ${innerSelector} {
              padding-right: 46px !important;
            }

            .errortext,
            .helpertext {
              margin-left: 16px;
              margin-top: 4px;
            }

          </style>
        `
      );

    }

  }

}

export default FilledInputMixin;
